import React from 'react';

import { TextInput } from '@vk-hr-tek/app-ui/form';
import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';

import { FreeTextAnswerSettings } from '@app/gen/community';

interface ContentSurveysFreeTextProps {
  fieldIndex: number;
  answerSettings: FreeTextAnswerSettings;
}

const MAX_LENGTH = 5000;

export const ContentSurveysFreeText = ({
  fieldIndex,
  answerSettings,
}: ContentSurveysFreeTextProps) => {
  const validator = useInject(ValidationService);

  const name = `questions[${fieldIndex}]`;
  const { min_length: minLength, max_length: maxLength } = answerSettings;

  return (
    <TextInput
      name={`${name}.answer`}
      multiline
      rows={3}
      maxRows={10}
      placeholder="Введите ответ"
      helperText="Количество символов ограничено"
      maxLength={maxLength || MAX_LENGTH}
      validateArray={[
        validator.required('Обязательное поле'),
        maxLength
          ? validator.maxLength(
              maxLength,
              `Максимальная длина ${maxLength} символов`,
            )
          : undefined,
        minLength
          ? validator.minLength(
              minLength,
              `Минимальная длина ${minLength} символов`,
            )
          : undefined,
      ]}
    />
  );
};
